<script setup>
    import { ElButton, ElCollapse, ElCollapseItem, ElIcon, ElSelect, ElTree } from 'element-plus';
    import { Delete } from '@element-plus/icons-vue';
    import { storeToRefs } from 'pinia';
    import { useProductStore } from '../../stores/fpe';
    import ProductAttribute from '../utility/product-attribute.vue';
    import { ref, toRaw } from 'vue';
    import { DCaret, ArrowRightBold } from '@element-plus/icons-vue'
    const store = useProductStore();
    const { strings, product, data_sets } = storeToRefs(store);
    const activeAttribute = ref(null);
    const new_attribute_type = ref('fpe_custom');

    const add_new_attribute = () => {
        
        if(new_attribute_type.value === ''){
            return;
        }

        if(new_attribute_type.value === 'fpe_custom'){
            
            product.value.attributes.push({
                id: 0,
                is_taxonomy: false,
                label: '',
                name: 'New Attribute',
                value: '',
                visible: true,
                variation: false,
                options: [],
                position: 0,
            });
        }else{

            // check if attribute already exists
            if(product.value.attributes.find((attribute) => attribute.name === new_attribute_type.value)){
                return;
            }

            const attribute = data_sets.value.attribute_taxonomies.find((attribute) => attribute.name_with_prefix === new_attribute_type.value);
            product.value.attributes.push({
                label: attribute.label,
                name: attribute.name_with_prefix,
                value: '',
                visible: true,
                variation: false,
                options: [],
                position: 0,
                is_taxonomy: true,
            });
        }

        new_attribute_type.value = 'fpe_custom';
    }


    const deleteAttribute = (name) => {
        // remove attribute from product.value.attributes where attribute.name === name
        const index = product.value.attributes.findIndex((attribute) => attribute.name === name);
        product.value.attributes.splice(index, 1);
    }

    const allowDrop = (draggingNode, dropNode, type) => {
        if(type === 'inner'){
            return false;
        }

        return true;
    }
</script>

<template>
    <el-collapse-item :title="strings.section_title_attributes" class="fpe-section-attributes" name="attributes" :icon="ArrowRightBold">
       <div class="fpe-product-attributes">
            
            <div class="fpe-field-wrapper fpe-field-inline fpe-add-new-attribute"> 
                <ElSelect v-model="new_attribute_type" @change="new_attribute_change">
                    <ElOption key="fpe_custom" value="fpe_custom" label="Custom Attribute" />
                    <ElOption
                        v-for="(attribute) in data_sets.attribute_taxonomies"
                        :key="attribute.name"
                        :label="attribute.label"
                        :value="attribute.name_with_prefix"
                        :disabled="product.attributes.find((attr) => attr.name === attribute.name_with_prefix)"
                    />
                </ElSelect>    
                <ElButton class="fpe-add-attribute" size="large" type="primary" plain @click="add_new_attribute">Add Attribute</ElButton>
            </div>

            <ElTree
                :data="product.attributes" 
                node-key="hash"
                default-expand-all
                :expand-on-click-node="false"
                draggable
                class="fpe-attributes"
                :icon="DCaret"
                :allow-drop="allowDrop"
                >
                
                <template #default="{ node, data }">
                    <ProductAttribute :attribute="data" :node="node" @ondelete="deleteAttribute" :type="product.type"/>     
                </template>    
            </ElTree>

            <!-- <ElCollapse v-model="activeAttribute" accordion draggable>
                
                <ElCollapseItem v-for="(attribute, index) in product.attributes" :key="index" :title="attribute.label || attribute.name" :name="index">
                    <ProductAttribute :attribute="attribute" :index="index" />
                    <ElButton class="fpe-remove-attribute" type="danger" :icon="Delete" @click="deleteAttribute(index)">Remove</ElButton>
                </ElCollapseItem>
            </ElCollapse> -->
                
       </div>   
    </el-collapse-item>
</template>